export var componentMetaParser = function componentMetaParser(designer) {
  var fun = function fun(ctx) {
    return {
      init: function init() {
        var material = ctx.material;
        material.onChangeAssets(function () {
          var assets = material.getAssets();
          var _assets$components = assets.components,
            components = _assets$components === void 0 ? [] : _assets$components;
          designer.buildComponentMetasMap(components);
        });
      }
    };
  };
  fun.pluginName = '___component_meta_parser___';
  return fun;
};